<div fxLayout="row" fxFlexFill fxLayoutGap="5px">
  <div
    *ngIf="!this.workflowNodes?.length && isDataLoaded$ | async"
    class="add-workflow-event"
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="10px"
  >
    <div class="add-workflow-event__icon" (click)="toggleEvents()">
      <mat-icon color="primary">add</mat-icon>
    </div>
    <app-workflow-palette-events
      *ngIf="eventsOpened"
      [viewModel]="viewModel"
      (eventClicked)="onCreateNode({ data: $event, rect: null })"
    ></app-workflow-palette-events>
  </div>

  <div *ngIf="!(isDataLoaded$ | async)" fxLayout="column" fxFlexFill class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>

  <f-flow
    *ngIf="isDataLoaded$ | async"
    fDraggable
    [fFlowId]="viewModel.key"
    (fLoaded)="onLoaded()"
    (fCreateConnection)="onCreateConnection($event)"
    (fReassignConnection)="onReassignConnection($event)"
    (fCreateNode)="onCreateNode($event)"
    (fSelectionChange)="onSelectionChange($event)"
  >
    <f-background>
      <f-circle-pattern></f-circle-pattern>
    </f-background>
    <f-line-alignment></f-line-alignment>
    <f-selection-area></f-selection-area>

    <f-canvas fZoom>
      <f-connection-for-create [fType]="cType">
        <svg
          id="normal_end"
          viewBox="0 0 700 700"
          fMarker
          [type]="eMarkerType.END"
          [height]="5"
          [width]="5"
          [refX]="4"
          [refY]="2.5"
        >
          <path d="M0,0L700,350L0,700L150,350z" />
        </svg>
      </f-connection-for-create>

      <f-connection
        [fSelectionDisabled]="true"
        [fReassignDisabled]="true"
        [fBehavior]="cBehavior"
        *ngFor="let connection of viewModel.connections"
        [fType]="cType"
        [fConnectionId]="connection.key"
        [fOutputId]="connection.from"
        [fInputId]="connection.to"
      >
        <svg
          id="normal_end"
          viewBox="0 0 700 700"
          fMarker
          [type]="eMarkerType.END"
          [height]="5"
          [width]="5"
          [refX]="4"
          [refY]="2.5"
        >
          <path d="M0,0L700,350L0,700L150,350z" />
        </svg>

        <svg
          id="selected_end"
          viewBox="0 0 700 700"
          fMarker
          [type]="eMarkerType.SELECTED_END"
          [height]="5"
          [width]="5"
          [refX]="4"
          [refY]="2.5"
        >
          <path d="M0,0L700,350L0,700L150,350z" />
        </svg>
      </f-connection>

      <workflow-node
        #fNode
        fNode
        fNodeInput
        *ngFor="let node of viewModel.nodes"
        [fNodeId]="node.key"
        [model]="node"
        [fInputId]="node.input"
        [fInputMultiple]="false"
        [fInputDisabled]="!node.input"
        [fInputConnectableSide]="eConnectableSide.TOP"
        [fNodePosition]="node.position"
        [isContentMinimized]="isContentMinimized"
        (valueChange)="onValueChanged(node, $event)"
        (removeConnection)="onRemoveConnection($event)"
        (fNodePositionChange)="onNodePositionChanged($event, node)"
        (click)="(null)"
        (actionClicked)="toggleActionOverlay($event, node)"
      >
      </workflow-node>
    </f-canvas>
    <f-selection-area></f-selection-area>
  </f-flow>

  <workflow-node-parameters
    [actionNotes]="actionNotes$ | async"
    [nodes$]="selectedNodes$.asObservable()"
    (parameterWindowClosed)="onParameterWindowClosed()"
    (nodeUpdated)="onNodeUpdated($event)"
  ></workflow-node-parameters>
</div>
<div
  class="edit-action-bar"
  style="padding-bottom: 10px; border-top: 1px solid #e6eefd; min-height: 5%"
  fxLayout="row"
  fxLayoutAlign="start center"
  fxLayoutGap="10px"
>
  <div style="margin-bottom: 5px" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
    <button
      mat-raised-button
      type="button"
      color="primary"
      matTooltip="Save changes"
      (click)="onSubmit()"
      [disabled]="submitted || !hasNodes || !isFormValid"
      [promiseBtn]="buttonSubmitPromise"
      *ngIf="hasEditAccess"
    >
      Save
    </button>

    <mat-icon
      *ngIf="eventsFlowDataFormService.errorsMessage"
      matTooltipClass="workflow-node__status-icon-custom-tooltip"
      [matTooltip]="eventsFlowDataFormService.errorsMessage"
      >warning</mat-icon
    >

    <button
      *ngIf="hasEditAccess && !isNewEvent"
      mat-raised-button
      color="warn"
      class="only-icon"
      type="button"
      matTooltip="Remove Event Flow"
      (click)="onDeleteClick()"
    >
      <mat-icon>delete</mat-icon>
    </button>
  </div>

  <workflow-action-panel
    [isContentMinimized]="isContentMinimized"
    (request)="onActionPanelEvent($event)"
  ></workflow-action-panel>
</div>
